import PropTypes from 'prop-types'
import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Button, Form, Message, Modal } from 'semantic-ui-react'

import APP from 'app'
import { trackEvent } from 'global-utils/Analytics'

import { authChangePassword, authChangePasswordCanceled } from 'actions/AuthActions'
import cloneDeep from 'lodash/cloneDeep'

import './ChangePassword.css'

class ChangePassword extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      pass: '',
      totalDirties: 2,
      updating: false,
    }
    this.dirties = {}
    this.errors = {}
  }

  static getDerivedStateFromProps(_props, state) {
    if (state.updating) {
      return {
        updating: false,
      }
    }
    return null
  }

  close = () => {
    this.props.authChangePasswordCanceled()
    this.props.onClose()
  }

  onChange = (field, event) => {
    const newState = cloneDeep(this.state)
    let value = (event.target.value || '').trim()
    let error = false
    let errorField = field

    switch (field) {
      case 'pass': {
        value = event.target.value || ''
        error = !value || value.length <= 5 || value !== newState.passConfirm
        break
      }
      case 'passConfirm': {
        errorField = 'pass'
        value = event.target.value || ''
        error = !value || value.length <= 5 || value !== newState.pass
        break
      }
      default: {
        break
      }
    }

    newState[field] = value
    this.dirties[field] = true

    if (error) {
      this.errors[errorField] = true
    } else {
      delete this.errors[errorField]
    }

    this.setState(newState)
  }

  onFormSubmit = (event) => {
    event.preventDefault()
    trackEvent('Authentication', 'Password Change', 'Attempt')
    const hasErrors = Object.keys(this.errors).length
    const totalDirties = Object.keys(this.dirties).length
    if (!this.state.updating && !hasErrors && totalDirties === this.state.totalDirties) {
      this.setState({
        updating: true,
      })
      this.props.authChangePassword(this.state.pass, APP.msg.token)
    }
  }

  render() {
    const { comment, error, open, title } = this.props
    const { updating } = this.state
    const errorMsg = error ? <Message content={error.msg} error header="Error" /> : ''
    const hasErrors = Object.keys(this.errors).length > 0
    return (
      <Modal className="ModalChangePassword" closeIcon="close" onClose={this.close} open={open} size="small">
        <Modal.Header>
          {title}
          {comment && (
            <div>
              <small>
                <em>{comment}</em>
              </small>
            </div>
          )}
        </Modal.Header>
        <Modal.Content>
          <Form key="mini" as="form" error={!!error || hasErrors} onSubmit={this.onFormSubmit} size="mini">
            <Form.Field
              control="input"
              error={!!this.errors.pass}
              label="Contraseña"
              onChange={(e) => this.onChange('pass', e)}
              placeholder="Contraseña 6+"
              type="password"
            />
            <Form.Field
              control="input"
              error={!!this.errors.pass}
              label="Confirmación"
              onChange={(e) => this.onChange('passConfirm', e)}
              placeholder="Contraseña 6+"
              type="password"
            />
            <Button
              className={`ModalChangePassword__button ${updating ? 'loading disabled' : 'primary'} ${
                Object.keys(this.dirties).length === this.state.totalDirties ? '' : ' disabled'
              }`}
              type="submit"
            >
              Cambiar
            </Button>
            {errorMsg}
          </Form>
        </Modal.Content>
      </Modal>
    )
  }
}

ChangePassword.propTypes = {
  authChangePassword: PropTypes.func.isRequired,
  authChangePasswordCanceled: PropTypes.func.isRequired,
  comment: PropTypes.string,
  error: PropTypes.object,
  onClose: PropTypes.func,
  open: PropTypes.bool,
  title: PropTypes.string,
}

ChangePassword.defaultProps = {
  comment: null,
  error: null,
  onClose: Function.prototype,
  open: false,
  title: 'Cambia tu contraseña',
}

function mapStateToProps(state, props) {
  return {
    error: state.auth.error,
    initialValues: props.obj, // pull initial values from account reducer
  }
}

export default connect(mapStateToProps, {
  authChangePassword,
  authChangePasswordCanceled,
})(ChangePassword)
